// extracted by mini-css-extract-plugin
export default {"container":"NotePopup_container__sZkJu","popup":"NotePopup_popup__2DV27","title":"NotePopup_title__jOKew","btnsWrapper":"NotePopup_btnsWrapper__VvA4e"};